module.exports = __webpack_public_path__ + "img/sbli_logo.af96ca89.jpeg";